var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, ngif, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};
pug_mixins["select"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.attributes) {
attributes.attributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "form-group"},attributes.groupAttributes]), true)) + "\u003E\u003Clabel" + (" class=\"control-label\""+pug.attr("for", attributes.key, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cselect" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"name": pug.escape(id),"id": pug.escape(id),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"disabled": pug.escape(attributes.disabled),"required": pug.escape(attributes.required),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
if (attributes.titleMap) {
// iterate attributes.titleMap
;(function(){
  var $$obj = attributes.titleMap;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

}
block && block();
pug_html = pug_html + "\u003C\u002Fselect\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"checkout_neoExtras-wrapper\"\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EMitarbeiterbezogen\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "ExtrainfoCtrl.neoExtras.strasse","title": "Straße","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie eine Straße ein."},"readonly": "true"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "ExtrainfoCtrl.neoExtras.plz","title": "PLZ","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie eine Postleitzahl ein."},"readonly": "true"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "ExtrainfoCtrl.neoExtras.ort","title": "Ort","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie einen Ort an."},"readonly": "true"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cbutton class=\"button button-primary right\" type=\"button\" ng-click=\"ExtrainfoCtrl.openAdressDialog()\"\u003EAdresse bearbeiten\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"ExtrainfoCtrl.needMail\"\u003E\u003Cdiv class=\"columns medium-9\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "ExtrainfoCtrl.employeeData.email","title": "E-Mail Adresse","ng-change": "ExtrainfoCtrl.resetUniqueMail()","validationMessages": {"unique":"Diese E-Mail Adresse existiert bereits.","email":"Bitte geben Sie eine gültige E-Mail Adresse an"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary tiny right\" type=\"button\" ng-disabled=\"!checkoutNeoExtrasForm['ExtrainfoCtrl.employeeData.email'].$valid\" ng-click=\"ExtrainfoCtrl.checkEmail()\"\u003EPrüfen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!ExtrainfoCtrl.busy &amp;&amp; ExtrainfoCtrl.customer_configuration &amp;&amp; ExtrainfoCtrl.customer_configuration.direct_contract_config.is_enabled &amp;&amp; ExtrainfoCtrl.extraAdvisor &amp;&amp; !!ExtrainfoCtrl.checkout_session &amp;&amp; !ExtrainfoCtrl.checkout_session.skipped_documents_upload\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchDirectContracting\" tabindex=\"1\"\u003E\u003Cspan\u003EDie Vertragsunterlagen werden am Ende der Beratung gedruckt, unterzeichnet und vom Berater in einem vorbereiteten Kuvert verschlossen und tag-gleich der Post übergeben.\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchDirectContracting","key": "ExtrainfoCtrl.checkout_session.direct_contract.is_enabled","labelHtmlClass": "switchbox-float-label","readonly": "ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail","ng-change": "ExtrainfoCtrl.handleDirectContractChange()"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"evBeginDate\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "ExtrainfoCtrl.neoExtras.evbegin","title": "Beginn der Optimierung ({{ ExtrainfoCtrl.evBeginMinDate &amp;&amp;  &quot;frühestens am &quot; + (ExtrainfoCtrl.evBeginMinDate | date)}} )","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie den Beginn der Optimierung an.","parse":"Bitte Datum im Format tt.mm.jjjj eingeben","dateMin":"Das Datum muss nach dem {{ ExtrainfoCtrl.evBeginMinDate | date }} liegen"},"readonly": "ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail","attributes": {"vn-date":"true","vn-date-min":"{{ ExtrainfoCtrl.evBeginMinDate.toUTCString() }}","vn-date-use-utc":"true","ng-change":"ExtrainfoCtrl.checkBavBegin()"},"fieldHtmlClass": "evBeginDate"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003Cdiv ng-hide=\"!ExtrainfoCtrl.neoExtras.evbegin\"\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"contractDate\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "ExtrainfoCtrl.neoExtras.vertragsabschluss","title": "Vertragsdatum","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie das Vertragsabschlussdatum an.","parse":"Bitte Datum im Format tt.mm.jjjj eingeben","dateMin":"Das Datum muss nach dem {{ ExtrainfoCtrl.vertragsabschlussMinDate | date }} liegen","dateMax":"Das Datum muss vor dem {{ ExtrainfoCtrl.neoExtras.evbegin | date }} liegen"},"readonly": "ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail","attributes": {"vn-date":"true","vn-date-use-utc":"true","vn-date-min":"{{ ExtrainfoCtrl.vertragsabschlussMinDate.toUTCString() }}","vn-date-max":"{{ ExtrainfoCtrl.neoExtras.evbegin.toUTCString() }}"},"fieldHtmlClass": "contractDate"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\"\u003E\u003Cbutton class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail\" data-cy=\"neo.checkout.basicComponents.employeeData.buttonNext\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","name": "checkoutNeoExtrasForm","id": "checkoutNeoExtrasForm","ng-submit": "ExtrainfoCtrl.proceed()"}
});
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};
pug_mixins["select"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.attributes) {
attributes.attributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "form-group"},attributes.groupAttributes]), true)) + "\u003E\u003Clabel" + (" class=\"control-label\""+pug.attr("for", attributes.key, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cselect" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"name": pug.escape(id),"id": pug.escape(id),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"disabled": pug.escape(attributes.disabled),"required": pug.escape(attributes.required),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
if (attributes.titleMap) {
// iterate attributes.titleMap
;(function(){
  var $$obj = attributes.titleMap;
  if ('number' == typeof $$obj.length) {
      for (var pug_index9 = 0, $$l = $$obj.length; pug_index9 < $$l; pug_index9++) {
        var option = $$obj[pug_index9];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index9 in $$obj) {
      $$l++;
      var option = $$obj[pug_index9];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

}
block && block();
pug_html = pug_html + "\u003C\u002Fselect\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"bigbox centered\" ng-if=\"ExtrainfoCtrl.iAmSpecialAdvisor\" ng-show=\"ExtrainfoCtrl.notMe\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EBerater Auswahl\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E";
pug_mixins["select"].call({
attributes: {"key": "ExtrainfoCtrl.selectedAdvisor","title": "Auszuführender Berater","attributes": {"ng-options":"advisor.id as advisor.id +' - '+ advisor.name for advisor in ExtrainfoCtrl.advisors","ng-change":"ExtrainfoCtrl.advisorSelection(advisor.id)"}}
});
pug_html = pug_html + "\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"ExtrainfoCtrl.proceed()\" ng-disabled=\"ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!--include .\u002Fmodule_boxes\u002F_insurances.pug--\u003E";
pug_mixins["bigbox"] = pug_interp = function(keys, addClass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ('bav' === keys) {
ngif = 'ExtrainfoCtrl.employee.data.insurances.bav.beitrag'
}
else {
if ('string' === typeof keys) {
keys = [keys]
}
// iterate keys
;(function(){
  var $$obj = keys;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
    }
  }
}).call(this);

ngif = keys.join(' || ')
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["bigbox","centered",addClass], [false,false,true]), false, true)+pug.attr("ng-if", ngif, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["bigbox"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EBAV\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "ExtrainfoCtrl.neoExtras.bavbegin","title": "Beginn der BAV","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie das Beginndatum der BAV an.","parse":"Bitte Datum im Format tt.mm.jjjj eingeben"},"attributes": {"vn-date":"true"}}
});
pug_html = pug_html + "\u003Cp class=\"small\" ng-if=\"ExtrainfoCtrl.bavNotification\"\u003EAktuell gespeicherts Datum {{ ExtrainfoCtrl.bavNotification | date}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!--.row(ng-if='ExtrainfoCtrl.iAmAdvisor'): .columns+select(\n  key= 'ExtrainfoCtrl.neoExtras.intversicherer'\n  title= 'Wahl des Versicherers'\n  required\n  validationMessages= {\n    required: 'W�hlen Sie eine Versicherung aus'\n  }\n  attributes={\n    'ng-options': 'insurance.id as insurance.firma for insurance in ExtrainfoCtrl.insurances'\n  }\n)\n--\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\" ng-hide=\"neoDocuments\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"ExtrainfoCtrl.proceed()\" ng-disabled=\"ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'bav', 'bav');
pug_mixins["bigbox"] = pug_interp = function(keys, addClass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ('bav' === keys) {
ngif = 'ExtrainfoCtrl.employee.data.insurances.bav.beitrag'
}
else {
if ('string' === typeof keys) {
keys = [keys]
}
// iterate keys
;(function(){
  var $$obj = keys;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
    }
  }
}).call(this);

ngif = keys.join(' || ')
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["bigbox","centered",addClass], [false,false,true]), false, true)+pug.attr("ng-if", ngif, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["bigbox"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EEssensschecks\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Cinput type=\"checkbox\" ng-model=\"ExtrainfoCtrl.neoExtras.boolkantine\" ng-true-value=\"'1'\" ng-false-value=\"'0'\" id=\"boolkantine\" name=\"boolkantine\" data-cy=\"neo.checkout.foodVoucher.employeeData.checkCanteen\"\u003E\u003Clabel for=\"boolkantine\"\u003E" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003Cspan\u003EKantinennutzung\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Clabel class=\"control-label\" for=\"kantinetage\"\u003ENutzung (Tagen pro Monat)\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.kantinetage\" name=\"kantinetage\" data-cy=\"neo.checkout.foodVoucher.employeeData.inputCanteenDays\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\" ng-hide=\"neoDocuments\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"ExtrainfoCtrl.proceed()\" ng-disabled=\"ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail\" data-cy=\"neo.checkout.basicComponents.employeeData.buttonNext\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'essenscheck', 'essenscheck');
pug_mixins["bigbox"] = pug_interp = function(keys, addClass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ('bav' === keys) {
ngif = 'ExtrainfoCtrl.employee.data.insurances.bav.beitrag'
}
else {
if ('string' === typeof keys) {
keys = [keys]
}
// iterate keys
;(function(){
  var $$obj = keys;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
    }
  }
}).call(this);

ngif = keys.join(' || ')
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["bigbox","centered",addClass], [false,false,true]), false, true)+pug.attr("ng-if", ngif, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["bigbox"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EDienstrad\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"control-label\" for=\"ebikeBrand\"\u003EMarke\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeBrand\" name=\"ebikeBrand\"\u003E\u003Clabel class=\"control-label\" for=\"ebikeSize\"\u003EGröße\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeSize\" name=\"ebikeSize\"\u003E\u003Clabel class=\"control-label\" for=\"ebikeOptions\"\u003EOptionen\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeOptions\" name=\"ebikeOptions\"\u003E\u003Clabel class=\"control-label\" for=\"ebikeModel\"\u003EModel\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeModel\" name=\"ebikeModel\"\u003E\u003Clabel class=\"control-label\" for=\"ebikeColor\"\u003EFarbe\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeColor\" name=\"ebikeColor\"\u003E\u003Clabel class=\"control-label\" for=\"ebikeType\"\u003ETyp\u003C\u002Flabel\u003E\u003Cselect name=\"ebikeType\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeType\"\u003E\u003Coption value=\"Fahrrad\"\u003EFahrrad\u003C\u002Foption\u003E\u003Coption value=\"Pedelec\"\u003EPedelec\u003C\u002Foption\u003E\u003Coption value=\"E-Bike\"\u003EE-Bike\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel class=\"control-label\" for=\"ebikeDealername\"\u003EHändler Name\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeDealername\" name=\"ebikeDealername\"\u003E\u003Clabel class=\"control-label\" for=\"ebikeDealerstr\"\u003EHändler Straße\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeDealerstr\" name=\"ebikeDealerstr\"\u003E\u003Clabel class=\"control-label\" for=\"ebikeDealerplz\"\u003EHändler PLZ\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeDealerplz\" name=\"ebikeDealerplz\"\u003E\u003Clabel class=\"control-label\" for=\"ebikeDealerort\"\u003EHändler Ort\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.ebikeDealerort\" name=\"ebikeDealerort\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\" ng-hide=\"neoDocuments\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"ExtrainfoCtrl.proceed()\" ng-disabled=\"ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'EBike', 'EBike');
pug_mixins["bigbox"] = pug_interp = function(keys, addClass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ('bav' === keys) {
ngif = 'ExtrainfoCtrl.employee.data.insurances.bav.beitrag'
}
else {
if ('string' === typeof keys) {
keys = [keys]
}
// iterate keys
;(function(){
  var $$obj = keys;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
    }
  }
}).call(this);

ngif = keys.join(' || ')
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["bigbox","centered",addClass], [false,false,true]), false, true)+pug.attr("ng-if", ngif, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["bigbox"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"header\"\u003E\u003Cspan\u003Efestnetz\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"control-label\" for=\"festnetztyp\"\u003EGerätetyp\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.festnetztyp\" name=\"festnetztyp\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\" ng-hide=\"neoDocuments\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"ExtrainfoCtrl.proceed()\" ng-disabled=\"ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'festnetz', 'festnetz');
pug_mixins["bigbox"] = pug_interp = function(keys, addClass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ('bav' === keys) {
ngif = 'ExtrainfoCtrl.employee.data.insurances.bav.beitrag'
}
else {
if ('string' === typeof keys) {
keys = [keys]
}
// iterate keys
;(function(){
  var $$obj = keys;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
    }
  }
}).call(this);

ngif = keys.join(' || ')
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["bigbox","centered",addClass], [false,false,true]), false, true)+pug.attr("ng-if", ngif, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["bigbox"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"header\"\u003E\u003Cspan\u003Ehandy\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"control-label\" for=\"handytyp\"\u003EGerätetyp\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.handytyp\" name=\"handytyp\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\" ng-hide=\"neoDocuments\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"ExtrainfoCtrl.proceed()\" ng-disabled=\"ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'handy', 'handy');
pug_mixins["bigbox"] = pug_interp = function(keys, addClass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ('bav' === keys) {
ngif = 'ExtrainfoCtrl.employee.data.insurances.bav.beitrag'
}
else {
if ('string' === typeof keys) {
keys = [keys]
}
// iterate keys
;(function(){
  var $$obj = keys;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
    }
  }
}).call(this);

ngif = keys.join(' || ')
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["bigbox","centered",addClass], [false,false,true]), false, true)+pug.attr("ng-if", ngif, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["bigbox"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EDienstwagengarage\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"control-label\" for=\"intgaragestellplatz\"\u003EStellplatz\u003C\u002Flabel\u003E\u003Cselect name=\"intgaragestellplatz\" ng-model=\"ExtrainfoCtrl.neoExtras.intgaragestellplatz\"\u003E\u003Coption value=\"Garage\"\u003EGarage\u003C\u002Foption\u003E\u003Coption value=\"Stellplatz\"\u003EStellplatz\u003C\u002Foption\u003E\u003Coption value=\"Carport\"\u003ECarport\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel class=\"control-label\" for=\"garagestrasse\"\u003Eabw. Straße\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.garagestrasse\" name=\"garagestrasse\"\u003E\u003Clabel class=\"control-label\" for=\"garageplz\"\u003Eabw. PLZ\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.garageplz\" name=\"garageplz\"\u003E\u003Clabel class=\"control-label\" for=\"garageort\"\u003Eabw. Ort\u003C\u002Flabel\u003E\u003Cinput class=\"from-control\" type=\"text\" ng-model=\"ExtrainfoCtrl.neoExtras.garageort\" name=\"garageort\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"ExtrainfoCtrl.proceed()\" ng-disabled=\"ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, ['dienstwagen_auslage', 'dienstwagen_miete'], 'dienstwagengarage');
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "ngif" in locals_for_with ?
        locals_for_with.ngif :
        typeof ngif !== 'undefined' ? ngif : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;